import BillingUploadProvider from "./BillingUploadContext";
import BillingUploadSteps from "./BillingUploadSteps";


const FileUploadPage: React.FC = () => {
  return (
    <div className="page-content">
      <div className="text-center">
        <h1>Φόρτωση αρχείου χρεώσεων</h1>
      </div>
      <hr className="mb-5"/>
      <BillingUploadProvider>
        <BillingUploadSteps />
      </BillingUploadProvider>
    </div>
  );
};

export default FileUploadPage;